import React from "react";
import { Badge } from "@jasperlabs/ui";

type BadgeProps = React.ComponentProps<typeof Badge>;

export const ExitedFundTag = (props: BadgeProps) => (
	<Badge {...props} variant="neutral" aria-label="Explanation of Exited Fund">
		Exited Fund
	</Badge>
);

export const OpenOfferTag = (props: BadgeProps) => (
	<Badge {...props} variant="success" aria-label="Explanation of Open Offer">
		Open
	</Badge>
);
